import React from 'react'

import { useBreakpoint } from '@sketch/components'

import { Wrapper, GlobeIcon, StyledText } from './EditingProfileNavBar.styles'

export const EditingProfileNavBar: React.FC = () => {
  const isMobile = !useBreakpoint('xs')

  return (
    <Wrapper>
      {isMobile ? (
        <>
          <GlobeIcon width="17" height="17" />
          <StyledText>Changes are applied immediately.</StyledText>
        </>
      ) : (
        <>
          <GlobeIcon width="17" height="17" />
          <StyledText>
            Public — Changes you make to your public profile will apply
            immediately.
          </StyledText>
        </>
      )}
    </Wrapper>
  )
}
